import { render, staticRenderFns } from "./SwitchOff.vue?vue&type=template&id=aab509ec&scoped=true"
import script from "./SwitchOff.vue?vue&type=script&lang=js"
export * from "./SwitchOff.vue?vue&type=script&lang=js"
import style0 from "./SwitchOff.vue?vue&type=style&index=0&id=aab509ec&prod&lang=scss&scoped=true"
import style1 from "./SwitchOff.vue?vue&type=style&index=1&id=aab509ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aab509ec",
  null
  
)

export default component.exports